var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { ui } from "../../../../../contracts";
import { BaseBet } from "../BaseBet";
let YourBet = class YourBet extends BaseBet {
    render() {
        return (React.createElement("div", { className: "rj-mybets-bet rj-mybets-your-bet", "data-uat": "mybets-bet", ref: this.ref },
            React.createElement("div", { className: "rj-mybets-bet-header" },
                React.createElement(ui.BetTitle, Object.assign({}, this.props.betTitle)),
                React.createElement(ui.BetStatusLabel, Object.assign({}, this.props.betStatusLabel)),
                React.createElement(ui.SelectionTitlesList, Object.assign({}, this.props.selectionTitlesList))),
            React.createElement(ui.TotalReturn, Object.assign({}, this.props.totalReturn)),
            this.props.bonusDetailsList ? React.createElement(ui.BonusDetailsList, Object.assign({}, this.props.bonusDetailsList)) : "",
            React.createElement(ui.EventDetails, Object.assign({}, this.props.eventDetails)),
            React.createElement(ui.BetSummary, Object.assign({}, this.props.betSummary))));
    }
};
YourBet = __decorate([
    observer
], YourBet);
export { YourBet };
//# sourceMappingURL=YourBet.js.map